export const emptyMapping = {
    mondayAccountId: 0,
    ticketType: '',
    freshApiKey: '',
    freshDomain: '',
    boardsMapping: []
  }

  export const newBoardsMapping = {
    mondayFields: {
      board: '',
      subject: null,
      requested_for: null,
      email: null,
      id_column: null,
      ticket_link: null
    },
    ticketFields: {
      group_id: null,
      responder_id: null,
      department_id: null,
      status: null,
      priority: null,
      urgency: null,
      impact: null,
      source: null
    },
    serviceRequestFields: {
      catalog_id: null,
      category_id: null,
    },
    customFields: [],
    childItems: []
  }